<template>
  <aside :class="$style.sidebar">
    <div :class="$style.inner">
      <p v-if="date" :class="$style.date">
        {{ $d(new Date(date), 'longDate') }}
      </p>
      <Title :title-params="title" :class="$style.title" />
    </div>
  </aside>
</template>

<script>
import Title from '~/components/Title'

export default {
  name: 'PressSidebar',

  components: {
    Title,
  },

  props: {
    title: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      default: '',
    },
  },

  beforeMount() {
    const element = document?.getElementById('mainRoot')
    if (element) element.style.overflowX = 'initial' // So the sidebar can be sticky
  },
}
</script>

<style lang="scss" module>
.inner {
  position: sticky;
  top: 96px;
}

.date {
  color: $gray-300;
  font-weight: 700;
  text-transform: uppercase;
}

.title {
  @include typo-extra-title;
  margin-top: 8px;

  font-weight: 200;
}
</style>
